import { config } from '@/config/env';

declare global {
	interface Window {
		FS?: (method: string, payload: object) => void;
	}
}

export function identifyUser(
	userId: string,
	properties: { displayName?: string; email?: string },
): void {
	window.FS?.('setIdentity', {
		uid: userId,
		properties: { ...properties, env: config.ENV },
	});
}

export function trackEvent(
	eventName: string,
	properties?: Record<string, unknown>,
): void {
	window.FS?.('trackEvent', {
		name: eventName,
		properties: { ...properties, env: config.ENV },
	});
}
